import { render, staticRenderFns } from "./key-value-storage.vue?vue&type=template&id=3766cca0&scoped=true"
import script from "./key-value-storage.vue?vue&type=script&lang=js"
export * from "./key-value-storage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3766cca0",
  null
  
)

export default component.exports